/**
 * Drainage Field Mapping
 * Maps drainage field names to their display labels and units
 * These labels should match the frontend_label or name in groundworks_rates_mapping.json
 */

/**
 * Mapping of drainage field names to their display labels
 */
export const DRAINAGE_FIELD_LABELS: { [fieldName: string]: string } = {
  // Manual Entry
  plots: "Plots",
  apartments: "Apartments",
  nmePhic: "NME PHIC",
  yardGully: "Yard Gully",
  drainageChannel: "Drainage Channel",
  landDrain: "Land Drain",
  cellularAtten: "Cellular Atten",

  // Polypipe Systems
  polypipeFoul: "Polypipe Foul",
  polypipeStorm: "Polypipe Storm",

  // Osma Systems (legacy)
  osmaFoul: "Osma Foul",
  osmaStorm: "Osma Storm",

  // OSMA Foul - Bends & Pipes & Items
  osma32mmBend: "OSMA FOUL",
  osmaPPIC: "OSMA FOUL - PPIC's (Nr)",
  osma50mmBend: "OSMA FOUL - Mini PPIC's (Nr)",
  osma68mmBend: "OSMA FOUL - SVP (Nr)",
  osma82mmBend: "OSMA FOUL - Concrete to rest bends (Nr)",
  osma110mmBend: "OSMA FOUL - 100/100 junctions (Nr)",
  osma32mmPipe: "OSMA FOUL - 100mm pipe (m)",
  osma40mmPipe: "OSMA FOUL - 100mm couplers (Nr)",
  osma50mmPipe: "OSMA FOUL - 100/150 junction (Nr)",
  osma68mmPipe: "OSMA FOUL - 150/150 junction (Nr)",
  osma82mmPipe: "OSMA FOUL - 150mm dia pipe (m)",
  osma110mmPipe: "OSMA FOUL - 150mm couplers (m)",
  gravel: "OSMA FOUL - Gravel (m)",
  concealedSetSurround: "OSMA FOUL - Concrete bed & surround (m)",
  tipOnSite: "OSMA FOUL - Tip onsite (m³)",
  osmaNmePpic: "OSMA FOUL - NME PPIC",
  osma600mmNmePpic: "600mm NME PPIC",

  // OSMA Foul - Excavation
  osmaExc100mm:
    "OSMA FOUL - Exc for & lay 100mm pipe, gravel b&s cart surplus to stockpile",
  osmaExc150mm:
    "OSMA FOUL - Exc for & lay 150mm pipe, gravel b&s cart surplus to stockpile",

  // OSMA Storm - Bends & Pipes & Items
  osmaStorm32mmBend: "OSMA STORM",
  osmaStorPPIC: "OSMA STORM - PPIC's (Nr)",
  osmaStorm50mmBend: "OSMA STORM - Rodding Eye (Nr)",
  osmaStorm68mmBend: "OSMA STORM - RWP (m)",
  osmaStorm100100JunctionTripleSocket:
    "OSMA STORM - 100/100 Junction (Triple Socket) (Nr)",
  osmaStorm82mmBend: "OSMA STORM - 100mm pipe (m)",
  osmaStorm110mmBend: "OSMA STORM - 100mm couplers (Nr)",
  osmaStorm32mmPipe: "OSMA STORM - 100/150 junction (Nr)",
  osmaStorm40mmPipe: "OSMA STORM - 150/150 junction (m)",
  osmaStorm50mmPipe: "OSMA STORM - 150mm dia pipe (Nr)",
  osmaStorm68mmPipe: "OSMA STORM - 150mm couplers (m)",
  osmaStormGravel: "OSMA STORM - Gravel (m)",
  osmaStormConcreteBedSurround: "OSMA STORM - Concrete bed & surround (m)",
  osmaStormTipOnsite: "OSMA STORM - Tip onsite (m³)",
  osmaStormNmePpic: "OSMA STORM - NME PPIC",
  osmaStorm600mmNmePpic: "600mm NME PPIC",
  osmaStormYardGully: "OSMA STORM - Yard Gully",
  osmaStormDrainageChannel: "Drainage Channel",
  osmaStormLandDrain: "Land Drain",

  // OSMA Storm - Excavation
  osmaStormExc100mm:
    "OSMA STORM - Exc for & lay 100mm pipe, gravel b&s cart surplus to stockpile",
  osmaStormExc150mm:
    "OSMA STORM - Exc for & lay 150mm pipe, gravel b&s cart surplus to stockpile",
  osmaStormExc225mm:
    "OSMA STORM - Exc for & lay 225mm pipe, gravel b&s cart surplus to stockpile",

  // Polypipe Foul - Bends & Pipes & Items
  polypipe32mmBend: "POLYPIPE FOUL",
  polypipePPIC: "POLYPIPE FOUL - PPIC's (Nr)",
  polypipe50mmBend: "POLYPIPE FOUL - Mini PPIC's (Nr)",
  polypipe68mmBend: "POLYPIPE FOUL - SVP (Nr)",
  polypipe82mmBend: "POLYPIPE FOUL - Concrete to rest bends (Nr)",
  polypipe110mmBend: "POLYPIPE FOUL - 100/100 Junctions (Nr)",
  polypipe32mmPipe: "POLYPIPE FOUL - 100mm pipe (m)",
  polypipe40mmPipe: "POLYPIPE FOUL - 100mm couplers (Nr)",
  polypipe50mmPipe: "POLYPIPE FOUL - 100/150 junction (Nr)",
  polypipe68mmPipe: "POLYPIPE FOUL - 150/150 junction (Nr)",
  polypipe82mmPipe: "POLYPIPE FOUL - 150mm dia pipe (m)",
  polypipe110mmPipe: "POLYPIPE FOUL - 150mm couplers (Nr)",
  polypipeGravel: "POLYPIPE FOUL - Gravel (m)",
  polypipeConcreteBedSurround: "POLYPIPE FOUL - Concrete bed & surround (m)",
  polypipeTipOnSite: "POLYPIPE FOUL - Tip onsite (m³)",
  polypipeNmePpic: "POLYPIPE FOUL - NME PPIC",
  polypipe600mmNmePpic: "600mm NME PPIC",

  // Polypipe Foul - Excavation
  polypipeExc100mm:
    "POLYPIPE FOUL - Exc for & lay 100mm pipe, gravel b&s cart surplus to stockpile",
  polypipeExc150mm:
    "POLYPIPE FOUL - Exc for & lay 150mm pipe, gravel b&s cart surplus to stockpile",

  // Polypipe Storm - Bends & Pipes & Items
  polypipeStorm32mmBend: "POLYPIPE STORM",
  polypipeStormPPIC: "POLYPIPE STORM - PPIC's (Nr)",
  polypipeStorm50mmBend: "POLYPIPE STORM - Rodding Eye (Nr)",
  polypipeStorm68mmBend: "POLYPIPE STORM - RWP (m)",
  polypipeStorm100100JunctionTripleSocket: "POLYPIPE STORM - 100/100 Junction (Triple Socket)",
  polypipeStorm82mmBend: "POLYPIPE STORM - 100mm pipe (m)",
  polypipeStorm110mmBend: "POLYPIPE STORM - 100mm couplers (Nr)",
  polypipeStorm32mmPipe: "POLYPIPE STORM - 100/150 junction (Nr)",
  polypipeStorm40mmPipe: "POLYPIPE STORM - 150/150 junction (m)",
  polypipeStorm50mmPipe: "POLYPIPE STORM - 150mm dia pipe (Nr)",
  polypipeStorm68mmPipe: "POLYPIPE STORM - 150mm couplers (m)",
  polypipeStormGravel: "POLYPIPE STORM - Gravel (m)",
  polypipeStormConcreteBedSurround:
    "POLYPIPE STORM - Concrete bed & surround (m)",
  polypipeStormTipOnSite: "POLYPIPE STORM - Tip onsite (m³)",
  polypipeStormNmePpic: "POLYPIPE STORM - NME PPIC",
  polypipeStorm600mmNmePpic: "600mm NME PPIC",
  polypipeStormYardGully: "POLYPIPE STORM - Yard Gully",
  polypipeStormDrainageChannel: "Drainage Channel",
  polypipeStormLandDrain: "Land Drain",

  // Polypipe Storm - Excavation
  polypipeStormExc100mm:
    "POLYPIPE STORM - Exc for & lay 100mm pipe, gravel b&s cart surplus to stockpile",
  polypipeStormExc150mm:
    "POLYPIPE STORM - Exc for & lay 150mm pipe, gravel b&s cart surplus to stockpile",
  polypipeStormExc225mm:
    "POLYPIPE STORM - Exc for & lay 225mm pipe, gravel b&s cart surplus to stockpile",
};

/**
 * Mapping of drainage field names to their units
 */
export const DRAINAGE_FIELD_UNITS: { [fieldName: string]: string } = {
  // Manual Entry
  plots: "",
  apartments: "",
  nmePhic: "Nr",
  yardGully: "Nr",
  drainageChannel: "m",
  landDrain: "m",
  cellularAtten: "Nr",

  // Polypipe Systems
  polypipeFoul: "Nr",
  polypipeStorm: "Nr",

  // Osma Systems (legacy)
  osmaFoul: "Nr",
  osmaStorm: "Nr",

  // OSMA Foul - Bends & Pipes & Items
  osma32mmBend: "Nr",
  osmaPPIC: "Nr",
  osma50mmBend: "Nr",
  osma68mmBend: "Nr",
  osma82mmBend: "Nr",
  osma110mmBend: "Nr",
  osma32mmPipe: "m",
  osma40mmPipe: "Nr",
  osma50mmPipe: "Nr",
  osma68mmPipe: "Nr",
  osma82mmPipe: "m",
  osma110mmPipe: "m",
  gravel: "m",
  concealedSetSurround: "m",
  tipOnSite: "m³",
  osmaNmePpic: "Nr",
  osma600mmNmePpic: "Nr",

  // OSMA Foul - Excavation
  osmaExc100mm: "m",
  osmaExc150mm: "m",

  // OSMA Storm - Bends & Pipes & Items
  osmaStorm32mmBend: "Nr",
  osmaStorPPIC: "Nr",
  osmaStorm50mmBend: "Nr",
  osmaStorm68mmBend: "m",
  osmaStorm100100JunctionTripleSocket: "Nr",
  osmaStorm82mmBend: "m",
  osmaStorm110mmBend: "Nr",
  osmaStorm32mmPipe: "Nr",
  osmaStorm40mmPipe: "m",
  osmaStorm50mmPipe: "Nr",
  osmaStorm68mmPipe: "m",
  osmaStormGravel: "m",
  osmaStormConcreteBedSurround: "m",
  osmaStormTipOnsite: "m³",
  osmaStormNmePpic: "Nr",
  osmaStorm600mmNmePpic: "Nr",
  osmaStormYardGully: "Nr",
  osmaStormDrainageChannel: "m",
  osmaStormLandDrain: "m",

  // OSMA Storm - Excavation
  osmaStormExc100mm: "m",
  osmaStormExc150mm: "m",
  osmaStormExc225mm: "m",

  // Polypipe Foul - Bends & Pipes & Items
  polypipe32mmBend: "Nr",
  polypipePPIC: "Nr",
  polypipe50mmBend: "Nr",
  polypipe68mmBend: "Nr",
  polypipe82mmBend: "Nr",
  polypipe110mmBend: "Nr",
  polypipe32mmPipe: "m",
  polypipe40mmPipe: "Nr",
  polypipe50mmPipe: "Nr",
  polypipe68mmPipe: "Nr",
  polypipe82mmPipe: "m",
  polypipe110mmPipe: "Nr",
  polypipeGravel: "m",
  polypipeConcreteBedSurround: "m",
  polypipeTipOnSite: "m³",
  polypipeNmePpic: "Nr",
  polypipe600mmNmePpic: "Nr",

  // Polypipe Foul - Excavation
  polypipeExc100mm: "m",
  polypipeExc150mm: "m",

  // Polypipe Storm - Bends & Pipes & Items
  polypipeStorm32mmBend: "Nr",
  polypipeStormPPIC: "Nr",
  polypipeStorm50mmBend: "Nr",
  polypipeStorm68mmBend: "m",
  polypipeStorm100100JunctionTripleSocket: "Nr",
  polypipeStorm82mmBend: "m",
  polypipeStorm110mmBend: "Nr",
  polypipeStorm32mmPipe: "Nr",
  polypipeStorm40mmPipe: "m",
  polypipeStorm50mmPipe: "Nr",
  polypipeStorm68mmPipe: "m",
  polypipeStormGravel: "m",
  polypipeStormConcreteBedSurround: "m",
  polypipeStormTipOnSite: "m³",
  polypipeStormNmePpic: "Nr",
  polypipeStorm600mmNmePpic: "Nr",
  polypipeStormYardGully: "Nr",
  polypipeStormDrainageChannel: "m",
  polypipeStormLandDrain: "m",

  // Polypipe Storm - Excavation
  polypipeStormExc100mm: "m",
  polypipeStormExc150mm: "m",
  polypipeStormExc225mm: "m",
};

/**
 * Get the display label for a drainage field
 */
export function getDrainageFieldLabel(fieldName: string): string | undefined {
  return DRAINAGE_FIELD_LABELS[fieldName];
}

/**
 * Get the unit for a drainage field
 */
export function getDrainageFieldUnit(fieldName: string): string | undefined {
  return DRAINAGE_FIELD_UNITS[fieldName];
}

/**
 * Reverse mapping: label to field name
 */
export const DRAINAGE_REVERSE_MAPPING: { [label: string]: string } = {};
Object.entries(DRAINAGE_FIELD_LABELS).forEach(([fieldName, label]) => {
  DRAINAGE_REVERSE_MAPPING[label] = fieldName;
});
